module.exports = __webpack_public_path__ + "bin/3e131b02a4f47b07014e48fdfa5f6591.jpg";